import { QueryClient } from '@tanstack/react-query';

// TODO: This should be better structured but we need to do a proper research https://packlink.atlassian.net/browse/PS-1002
//       This default config has been thought to "play safe" meanwhile
export function configureQueryClient() {
    return new QueryClient({
        defaultOptions: { queries: { retry: false, refetchOnWindowFocus: false, refetchOnReconnect: false } },
    });
}
